import { useMemo } from 'react'
import { rewriteTemplateHtml } from '@/lib/templateHtml'

/**
 * Renders a page body exactly as authored in the hospital template.
 * Only asset paths and internal links are rewritten (see templateHtml.ts);
 * every class, structure and data attribute is preserved verbatim so the
 * original CSS, Bootstrap components and jQuery plugins behave identically.
 */
export function TemplatePage({ html }: { html: string }) {
  // Keep a *stable* object reference for `dangerouslySetInnerHTML`. React
  // compares that prop by reference, so re-creating the `{ __html }` object on
  // every render makes React re-assign innerHTML, wiping the background images,
  // sliders, counters and popups that the template initializer applied.
  const innerHtml = useMemo(() => ({ __html: rewriteTemplateHtml(html) }), [html])
  return <div className="template-page" dangerouslySetInnerHTML={innerHtml} />
}
